<ng-container *ngIf="source.length > 0">
  <app-data-grid [columns]="columns"
                 [source]="source"></app-data-grid>
</ng-container>
<div *ngIf="source.length === 0">
  No {{headingTitle}}
</div>
